import React, { useState, useEffect } from 'react';
import { TableState, SeatState } from './PokerTable';
import {
  newRound,
  showFlop,
  showTurn,
  showRiver,
  givePotTo,
  resetRound,
  kickPlayer,
} from './api';
import { numActivePlayers } from './common';

interface Props {
  tableState: TableState;
}

export default function({ tableState }: Props) {
  const [giveAmount, setGiveAmount] = useState(tableState.pot);
  const [giveTo, setGiveTo] = useState(-1);
  const [toKick, setToKick] = useState(-1);

  useEffect(() => {
    setGiveAmount(tableState.pot);
  }, [tableState.pot]);

  const _getSeatOptions = () => {
    const result: any[] = [
      <option key="select" value="-1">
        Select
      </option>,
    ];
    tableState.seats.forEach((s, i) => {
      if (s.state === SeatState.ACTIVE || s.state === SeatState.SHOW) {
        result.push(
          <option key={i} value={i}>
            {s.name}
          </option>,
        );
      }
    });
    return result;
  };

  const haveCardsBeenDealt = tableState.seats.some(s => {
    return s.cards.length === 2 && s.cards[0] !== '' && s.cards[1] !== '';
  });
  return (
    <div className="actions">
      <div className="title">Dealer actions</div>
      <button
        className="w-full"
        onClick={() => newRound()}
        disabled={tableState.pot !== 0 || numActivePlayers(tableState) < 2}
      >
        Deal new round
      </button>
      <br />
      <button
        disabled={!haveCardsBeenDealt}
        className="w-1-3"
        onClick={() => showFlop()}
      >
        Flop
      </button>
      <button
        className="w-1-3"
        disabled={tableState.communityCards.length < 3}
        onClick={() => showTurn()}
      >
        Turn
      </button>
      <button
        className="w-1-3"
        disabled={tableState.communityCards.length < 4}
        onClick={() => showRiver()}
      >
        River
      </button>
      <br />
      <br />
      <div className="distribute-pot">
        <b>Distribute pot</b>
        <br />
        <br />
        <div className="flex">
          <div className="w-1-2 mr-10">
            <div>Amount</div>
            <input
              className="w-full"
              type="range"
              min="0"
              max={tableState.pot}
              value={giveAmount}
              onChange={e => setGiveAmount(parseInt(e.target.value, 10))}
            />
          </div>
          <div className="w-1-2">
            <div>Seat</div>
            <select
              disabled={numActivePlayers(tableState) < 2}
              className="w-full"
              value={giveTo}
              onChange={e => setGiveTo(parseInt(e.target.value, 10))}
            >
              {_getSeatOptions()}
            </select>
          </div>
        </div>
        <button
          className="w-full"
          disabled={giveTo === -1}
          onClick={async () => {
            await givePotTo(giveTo, giveAmount);

            setGiveTo(-1);
            setGiveAmount(tableState.pot - giveAmount);
          }}
        >
          Give ${giveAmount}{' '}
          {giveTo === -1 ? '' : `to ${tableState.seats[giveTo].name}`}
        </button>{' '}
      </div>
      <br />
      <br />
      <button
        className="danger w-full"
        onClick={() => resetRound()}
        disabled={tableState.pot === 0}
      >
        Return bets and reset round
      </button>
      <div>
        <select
          className="danger w-2-3"
          value={toKick}
          onChange={e => setToKick(parseInt(e.target.value, 10))}
        >
          {_getSeatOptions()}
        </select>{' '}
        <button className="danger w-1-3" onClick={() => kickPlayer(toKick)}>
          Kick player
        </button>
      </div>
    </div>
  );
}
